import { HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, tap } from 'rxjs'
import { v4 as uuidv4 } from 'uuid'

import { BookingDetails } from '../domain/BookingDetails'
import { BookingRequest } from '../domain/BookingRequest'
import { Context } from '../domain/Context'
import { BookingService } from './booking.service'

@Injectable()
export class BookingSubmissionSession {

    private unresolvedRequest?: BookingRequest

    constructor(private bookingService: BookingService) {}

    get pendingRequest(): BookingRequest | undefined {
        return this.unresolvedRequest
    }

    submit(context: Context, request: BookingRequest): Observable<BookingDetails> {
        const submittedRequest = this.requestForSubmission(request)
        return this.bookingService.requestBooking(context, submittedRequest)
            .pipe(
                tap({
                    next: () => this.unresolvedRequest = undefined,
                    error: (error: HttpErrorResponse) => {
                        this.unresolvedRequest = this.isDefinitiveFailure(error)
                            ? undefined
                            : submittedRequest
                    },
                })
            )
    }

    private requestForSubmission(request: BookingRequest): BookingRequest {
        if (!this.unresolvedRequest) {
            return request
        }
        if (this.hasSamePayload(this.unresolvedRequest, request)) {
            return this.unresolvedRequest
        }
        return {
            ...request,
            id: uuidv4(),
        }
    }

    private hasSamePayload(first: BookingRequest, second: BookingRequest): boolean {
        return JSON.stringify({ ...first, id: undefined }) ===
            JSON.stringify({ ...second, id: undefined })
    }

    isDefinitiveFailure(error: HttpErrorResponse): boolean {
        return error.status >= 400 && error.status < 500 && error.status !== 408
    }

    reset(): void {
        this.unresolvedRequest = undefined
    }
}
